/* eslint-disable max-len */
export default function ControlTypeController(
  $location,
  $q,
  $rootScope,
  $scope,
  $timeout,
  alerts,
  authorizationService,
  confirmDialog,
  editControlTypeDialog,
  deleteControlTypeConfirmDialog,
  loaderService,
  controlDataService,
  controlSharedModelService,
  ssDialogService,
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.handleEditClick = _handleEditClick;
  vm.handleDeleteClick = _handleDeleteClick;
  vm.handleExpandControlClick = _handleExpandControlClick;
  vm.handleUnassignClick = _handleUnassignClick;
  vm.hasData = false;

  _activate();


  function _activate() {
    _initControlData();
  }

  function _initControlData() {
    if (vm.controlType) {
      vm.controlType = controlSharedModelService.transformToEffectivenessCssClass(vm.controlType);
    }
  }

  function _handleEditClick($event) {
    $q.all([
      controlDataService.getControlType(vm.controlType.customerControlTypeId),
      getInitControlAdmin()
    ]).then((response) => {
      ssDialogService.dialogs.controlAdmin.editControlTypeDialog = ssDialogService.alert(
        editControlTypeDialog.getOptions($event, {
          controlType: response[0].data,
          controlResults: controlSharedModelService.ControlResults,
          controlPreventiveEffectivenesses: controlSharedModelService.ControlPreventiveEffectivenesses,
          controlDetectiveEffectivenesses: controlSharedModelService.ControlDetectiveEffectivenesses,
          controlCorrectiveEffectivenesses: controlSharedModelService.ControlCorrectiveEffectivenesses,
          controlAdministrativeNatures: controlSharedModelService.ControlAdministrativeNatures,
          controlPhysicalNatures: controlSharedModelService.ControlPhysicalNatures,
          controlTechnicalNatures: controlSharedModelService.ControlTechnicalNatures,
          controlPrimaryControlTypes: controlSharedModelService.ControlPrimaryControlTypes,
          controlCompensatingControlTypes: controlSharedModelService.ControlCompensatingControlTypes,
          controlReviewSchedules: controlSharedModelService.ControlReviewSchedules,
          controlReviewTypes: controlSharedModelService.ControlReviewTypes,
        })
      );

      ssDialogService.show(ssDialogService.dialogs.controlAdmin.editControlTypeDialog);
    });
  }

  function _handleDeleteClick($event) {
    ssDialogService.dialogs.controlAdmin.deleteControlTypeConfirmDialog = ssDialogService.alert(
      deleteControlTypeConfirmDialog.getOptions($event, {
        controlType: vm.controlType,
        riskType: vm.riskType,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.controlAdmin.deleteControlTypeConfirmDialog);
  }

  function _handleExpandControlClick() {
    if (!vm.hasData) {
      controlDataService.getControlType(vm.controlType.customerControlTypeId).then((response) => {
        vm.controlType = angular.copy(response.data);
        vm.controlType = controlSharedModelService.transformToEffectivenessCssClass(vm.controlType);
        vm.hasData = true;
      });
    }
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleUnassignClick($event) {
    ssDialogService.dialogs.controlAdmin.unAssignControlTypeDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unassign Control Type?',
        message: `Are you sure you want to unassign the Control Type "${vm.controlType.name}"?`,
        handleYesClick: () => {
          _handleConfirmUnassignClick();
        },
        handleNoClick: () => {
          _handleCancelUnassignClick();
        },
      })
    );

    ssDialogService.show(ssDialogService.dialogs.controlAdmin.unAssignControlTypeDialog);
  }

  function _handleConfirmUnassignClick() {
    controlDataService.unAssignControlType(
      vm.assetType.customerAssetTypeId,
      vm.riskTypeControlTypeId,
      vm.controlType
    )
      .then((response) => {
        if (response.status === 200) {
          alerts.success(`The control type "${vm.controlType.name}" was successfully unassigned.`);
          $rootScope.$broadcast('refreshAssetTypes');
          $rootScope.$broadcast('pra_control-type-deleted', {
            controlType: vm.controlType,
            riskType: vm.riskType
          });
          _closeUnassignDialog();
        } else {
          alerts.error('An error occurred while unassigning the control type.');
        }
      });
  }

  function _handleCancelUnassignClick() {
    _closeUnassignDialog();
  }

  function _closeUnassignDialog() {
    ssDialogService.hide(ssDialogService.dialogs.controlAdmin.unAssignControlTypeDialog);
  }

  function getInitControlAdmin() {
    if (controlSharedModelService.ControlPreventiveEffectivenesses && controlSharedModelService.ControlPreventiveEffectivenesses.length > 0) {
      return Promise.resolve();
    }
    return controlDataService.initControlAdmin().then((getControlInitResponse) => {
      if (!getControlInitResponse.data) {
        alerts.error('Error occurred get control init data.');
      } else {
        if (getControlInitResponse.data.ControlResults) {
          controlSharedModelService.ControlResults = getControlInitResponse.data.ControlResults.result;
        }

        if (getControlInitResponse.data.ControlPreventiveEffectivenesses) {
          controlSharedModelService.ControlPreventiveEffectivenesses = getControlInitResponse.data.ControlPreventiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlDetectiveEffectivenesses) {
          controlSharedModelService.ControlDetectiveEffectivenesses = getControlInitResponse.data.ControlDetectiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlCorrectiveEffectivenesses) {
          controlSharedModelService.ControlCorrectiveEffectivenesses = getControlInitResponse.data.ControlCorrectiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlAdministrativeNatures) {
          controlSharedModelService.ControlAdministrativeNatures = getControlInitResponse.data.ControlAdministrativeNatures.result;
        }

        if (getControlInitResponse.data.ControlPhysicalNatures) {
          controlSharedModelService.ControlPhysicalNatures = getControlInitResponse.data.ControlPhysicalNatures.result;
        }

        if (getControlInitResponse.data.ControlTechnicalNatures) {
          controlSharedModelService.ControlTechnicalNatures = getControlInitResponse.data.ControlTechnicalNatures.result;
        }

        if (getControlInitResponse.data.ControlPrimaryControlTypes) {
          controlSharedModelService.ControlPrimaryControlTypes = getControlInitResponse.data.ControlPrimaryControlTypes.result;
        }

        if (getControlInitResponse.data.ControlCompensatingControlTypes) {
          controlSharedModelService.ControlCompensatingControlTypes = getControlInitResponse.data.ControlCompensatingControlTypes.result;
        }

        if (getControlInitResponse.data.ControlReviewSchedules) {
          controlSharedModelService.ControlReviewSchedules = getControlInitResponse.data.ControlReviewSchedules.result;
        }

        if (getControlInitResponse.data.ControlReviewTypes) {
          controlSharedModelService.ControlReviewTypes = getControlInitResponse.data.ControlReviewTypes.result;
        }

        if (getControlInitResponse.data.ControlTypes) {
          controlSharedModelService.ControlTypes = getControlInitResponse.data.ControlTypes.result;
        }
      }
    });
  }
}

ControlTypeController.$inject = [
  '$location',
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',
  'alerts',
  'authorizationService',
  'confirmDialog',
  'editControlTypeDialog',
  'deleteControlTypeConfirmDialog',
  'loaderService',
  'controlDataService',
  'controlSharedModelService',
  'ssDialogService',
];
